/* prettier: { "printWidth": 200 } */

const branding = {
  AppBranding: {
    CompanyName: 'brand__app_branding__company_name',
    AppName: 'brand__app_branding__app_name',
    CompanyTin: 'brand__app_branding__company_tin',
    CompanyType: 'brand__app_branding__company_type',
    ThemeColor: 'brand__app_branding__theme_color',
    AboutUsContent: 'brand__app_branding__about_us_content',
    MobileApp: {
      BundleIdentifier: 'brand__app_branding__mobile_app__bundle_identifier',
      IosApp: {
        Name: 'brand__app_branding__mobile_app__ios_app__name',
        ID: 'brand__app_branding__mobile_app__ios_app__id',
      },
      DeepLinking: {
        Protocols: 'brand__app_branding__mobile_app__deep_linking__protocols',
        Domains: 'brand__app_branding__mobile_app__deep_linking__domains',
      },
    },
  },
  Domain: {
    Assets: 'brand__domain__assets',
    Admin: 'brand__domain__admin',
    Seller: 'brand__domain__seller',
    Webapp: 'brand__domain__webapp',
    Corporate: 'brand__domain__corporate',
    Maas: 'brand__domain__maas',
  },
  UI: {
    Theming: {
      Fonts: 'brand__ui__theming__fonts',
      Theme: {
        Color: {
          Primary: 'brand__ui__theming__theme__color__primary',
        },
        Override: {
          Gradients: 'brand__ui__theming__theme__override__gradients',
          Colors: 'brand__ui__theming__theme__override__colors',
          Styles: 'brand__ui__theming__theme__override__styles',
          Shadows: 'brand__ui__theming__theme__override__shadows',
          FontSizes: 'brand__ui__theming__theme__override__font_sizes',
          Space: 'brand__ui__theming__theme__override__space',
          Sizes: 'brand__ui__theming__theme__override__sizes',
        },
      },
    },
    Settings: {
      Common: {
        Product: {
          CallToActionButton: 'brand__ui__settings__common__product__call_to_action_button',
          DoNotUseHexColorSelector:
            'brand__ui__settings__common__product__do_not_use_hex_color_selector',
        },
      },
      MobileApp: {
        SplashScreen: {
          Background: 'brand__ui__settings__mobile_app__splash_screen__background',
          Foreground: 'brand__ui__settings__mobile_app__splash_screen__foreground',
        },
      },
      Webapp: {
        Header: {
          SearchVariant: 'brand__ui__settings__webapp__header__search_variant',
          UseColoredNavbar: 'brand__ui__settings__webapp__header__use_colored_navbar',
        },
        Product: {
          UseSingleProductNewDesign:
            'brand__ui__settings__webapp__product__use_single_product_new_design',
          OpenInNewTab: 'brand__ui__settings__webapp__product__open_in_new_tab',
        },
      },
      Dashboard: {
        DisableProductSearchForSellerAndAdmin:
          'brand__ui__settings__dashboard__disable_product_search_for_seller_and_admin',
      },
      Corporation: {
        DesktopLargeContainer: 'brand__ui__settings__corporation__desktop_large_container',
        DesktopWhatToSellStyleClassName:
          'brand__ui__settings__corporation__desktop_what_to_sell_style_class_name',
        ShowTopCompanies: 'brand__ui__settings__corporation__show_top_companies',
        BenefitsForSellers: {
          AllInOne: 'brand__ui__settings__corporation__benefits_for_sellers__all_in_one',
          BusinessVerification:
            'brand__ui__settings__corporation__benefits_for_sellers__business_verification',
          BuiltInMarketingTools:
            'brand__ui__settings__corporation__benefits_for_sellers__built_in_marketing_tools',
          CustomerSupport:
            'brand__ui__settings__corporation__benefits_for_sellers__customer_support',
          ReachRegionalAudience:
            'brand__ui__settings__corporation__benefits_for_sellers__reach_regional_audience',
          DataDrivenInsightsPersonalization:
            'brand__ui__settings__corporation__benefits_for_sellers__data_driven_insights_personalization',
          EasyAndIntuitiveDashboard:
            'brand__ui__settings__corporation__benefits_for_sellers__easy_and_intuitive_dashboard',
        },
        WeOfferFeatures: {
          BusinessVerification:
            'brand__ui__settings__corporation__we_offer_features__business_verification',
          BuiltInMarketingTools:
            'brand__ui__settings__corporation__we_offer_features__built_in_marketing_tools',
          CustomerSupport: 'brand__ui__settings__corporation__we_offer_features__customer_support',
          LogisticsAndLegalSupport:
            'brand__ui__settings__corporation__we_offer_features__logistics_and_legal_support',
        },
      },
    },
  },
  CountryParam: {
    InitialCountry: 'brand__country_param__initial_country',
    Currency: 'brand__country_param__currency',
    Locale: {
      Default: 'brand__country_param__locale__default',
      List: 'brand__country_param__locale__list',
    },
    Map: {
      Provider: 'brand__country_param__map__provider',
      CountryRestrictions: 'brand__country_param__map__country_restrictions',
      InitialZoom: 'brand__country_param__map__initial_zoom',
      InitialCenter: {
        Latitude: 'brand__country_param__map__initial_center__latitude',
        Longitude: 'brand__country_param__map__initial_center__longitude',
      },
    },
    Shipping: {
      ShipFrom: 'brand__country_param__shipping__ship_from',
      ShipTo: 'brand__country_param__shipping__ship_to',
      DeliveryDateAfterDays: 'brand__country_param__shipping__delivery_date_after_days',
    },
  },
  Payment: {
    CustomerMinOrderValue: 'brand__payment__customer_min_order_value',
    Providers: 'brand__payment__providers',
  },
  MetaTags: {
    Title: 'brand__meta_tags__title',
    Description: 'brand__meta_tags__description',
    Keywords: 'brand__meta_tags__keywords',
  },
  Order: {
    AutoRejectHours: 'brand__order__auto_reject_hours',
  },
  LegalInfo: {
    Provider: 'brand__legal_info__provider',
  },
  Delivery: {
    Providers: {
      Enabled: 'brand__delivery__providers__enabled',
      Defaults: {
        Pickup: 'brand__delivery__providers__defaults__pickup',
        Delivery: 'brand__delivery__providers__defaults__delivery',
        Express: 'brand__delivery__providers__defaults__express',
      },
    },
    Configs: 'brand__delivery__configs',
    PickupAddress: 'brand__delivery__pickup_address',
  },
  Contacts: {
    Addresses: 'brand__contacts__addresses',
    Phones: 'brand__contacts__phones',
    Emails: 'brand__contacts__email',
    NoReplyEmail: 'brand__contacts__no_reply_email',
  },
  Links: {
    MobileApp: {
      GooglePlay: 'brand__links__mobile_app__google_play',
      AppleAppStore: 'brand__links__mobile_app__apple_app_store',
      AppDownloadLink: 'brand__links__mobile_app__app_download_link',
    },
    Social: {
      Facebook: 'brand__links__social__facebook',
      Instagram: 'brand__links__social__instagram',
      LinkedIn: 'brand__links__social__linked_in',
      YouTube: 'brand__links__social__you_tube',
      Telegram: 'brand__links__social__telegram',
    },
    Booking: {
      Calendly: 'brand__links__booking__calendly',
    },
  },
  FeatureFlag: {
    AgeRestricted: 'brand__feature_flag__age_restricted',
    DisableECommerceFlow: 'brand__feature_flag__disable_ecommerce_flow',
    Chat: 'brand__feature_flag__chat',
    ShoppingCart: 'brand__feature_flag__cart_enabled',
    ShoppingCartContext: 'brand__feature_flag__shopping_cart_context_enabled',
    AddressSelectionEnabled: 'brand__feature_flag__address_selection_enabled',
    CheckoutDateRangePicker: 'brand__feature_flag__checkout_date_range_picker',
    BookingHistoryEnabled: 'brand__feature_flag__booking_history_enabled',
    Auth: 'brand__feature_flag__auth',
    Note: 'brand__feature_flag__checkout_note_enabled',
    SimpleOrderRequest: 'brand__feature_flag__simple_order_request',
    SimpleCheckoutEnabled: 'brand__feature_flag__simple_checkout_enabled',
    CustomerSupport: 'brand__feature_flag__customer_support',
    PhysicalCustomer: 'brand__feature_flag__physical_customer',
    LegalCustomer: 'brand__feature_flag__legal_customer',
    LegalCustomerGrant: 'brand__feature_flag__legal_customer_grant',
    DownloadAppModal: 'brand__feature_flag__download_app_modal',
    Collection: 'brand__feature_flag__collection',
    CollectionShareEnabled: 'brand__feature_flag__collection_share_enabled',
    ContactUs: 'brand__feature_flag__contact_us',
    AboutUs: 'brand__feature_flag__about_us',
    Collaboration: 'brand__feature_flag__collaboration',
    ProductWeight: 'brand__feature_flag__product_weight',
    ProductCountry: 'brand__feature_flag__product_country',
    AdminPushNotifications: 'brand__feature_flag__admin_push_notifications',
    AdminBadges: 'brand__feature_flag__admin_badges',
    DeliveryEnabled: 'brand__feature_flag__delivery_enabled',
    DeliveryPickupEnabled: 'brand__feature_flag__delivery_pickup_enabled',
    ShoppingCartCustomAmount: 'brand__feature_flag__shopping_cart_custom_amount',
    ExpressEnabled: 'brand__feature_flag__express_enabled',
    ProductShare: 'brand__feature_flag__product_share',
    ShowProfileFaq: 'brand__feature_flag__show_profile_faq',
    ShowHelpCenter: 'brand__feature_flag__show_help_center',
    SellerSinglePageAbility: 'brand__feature_flag__seller_single_page_ability',
    MoneyTransfer: 'brand__feature_flag__money_transfer',
    AllowAdminCustomDeliveryStatuses: 'brand__feature_flag__allow_admin_custom_delivery_statuses',
    CustomerBonus: 'brand__feature_flag__customer_bonus',
    BottomTabNavigation: 'brand__feature_flag__bottom_tab_navigation_hidden',
    PaymentMethods: 'brand__feature_flag__payment_methods',
    Orders: 'brand__feature_flag__orders_enabled',
    Languages: 'brand__feature_flag__languages_enabled',
    PrivacySecurity: 'brand__feature_flag__privacy_security_enabled',
    PrivacyPolicy: 'brand__feature_flag__privacy_policy_enabled',
    SharedAccountScreen: 'brand__feature_flag__mobile_app_account_screen_shared',
    SharedBonusScreen: 'brand__feature_flag__mobile_app_bonus_screen_shared',
    SharedLanguagesScreen: 'brand__feature_flag__mobile_app_languages_screen_shared',
    SharedProfileScreen: 'brand__feature_flag__mobile_app_profile_screen_shared',
    BonusMutator: 'brand__feature_flag__show_bonus_mutator',
    UploadProductUpdateExcel: 'brand__feature_flag__upload_product_update_excel',
    EditProductAndProductDetail: 'brand__feature_flag__edit_product_and_product_detail',
    ProductPrice: 'brand__feature_flag__product_price_hidden',
    SellerSettingsGalleryTab: 'brand__feature_flag__seller_settings_gallery_tab',
    AdminSellerSupport: 'brand__feature_flag__admin_seller_support',
    AdminSellerTab: 'brand__feature_flag__admin_seller_tab',
    AdminReviewProducts: 'brand__feature_flag__admin_review_products',
    DynamicFilters: 'brand__feature_flag__dynamic_filters',
    RegisterShowPhoneInput: 'brand__feature_flag__register_show_phone_input',
    UsesV2ApiFlow: 'brand__feature_flag__uses_v2_api_flow',
  },
};

export default branding;
